/* eslint-disable react-hooks/exhaustive-deps */
import { CustomRolePermissionDto } from '../../../../../api-client';
import React, { useMemo } from 'react';
import { RichTable } from '../../../../../common';
import { TableData } from '@hiiretail/synergy-ui/dist/types/components/surfaces/Table/Table.types';
import { CustomRolePermissionAttributesRow } from './CustomRolePermissionAttributesRow/CustomRolePermissionAttributesRow';
import { DeletePermissionFromCustomRoleButton } from './DeletePermissionFromCustomRoleButton/DeletePermissionFromCustomRoleButton';
import { RemoveAttributeFunction } from '../../../hooks/useRemoveAttributeFacade';

type CustomRolePermissionsTableProps = {
  permissions: CustomRolePermissionDto[];
  onAddPermissionBtnClick: () => void;
  isLoading: boolean;
  isRemovingAttribute: boolean;
  openAddAttributeModal: (permission: CustomRolePermissionDto) => () => void;
  removeAttribute: RemoveAttributeFunction;
  openCustomRolePermissionDeleteModal: (permission: CustomRolePermissionDto) => void;
};

type CustomRolePermissionsTableComponent = React.FC<CustomRolePermissionsTableProps>;

export const CustomRolePermissionsTable: CustomRolePermissionsTableComponent = ({
  permissions,
  isLoading,
  openAddAttributeModal,
  onAddPermissionBtnClick,
  isRemovingAttribute,
  removeAttribute,
  openCustomRolePermissionDeleteModal,
}) => {
  const tableColumns = useMemo(
    () => [
      { Header: 'Identifier', accessor: 'id', width: 100 },
      {
        Header: 'Attributes',
        accessor: 'attributes',
        Cell: ({
          row: { original },
        }: {
          row: {
            original: CustomRolePermissionDto;
          };
        }) => (
          <CustomRolePermissionAttributesRow
            permission={original}
            isFetchingAttributes={isLoading}
            isRemovingAttribute={isRemovingAttribute}
            openAddAttributeModal={openAddAttributeModal(original)}
            removeAttribute={removeAttribute}
          />
        ),
      },
      {
        Header: 'Actions',
        width: 50,
        Cell: ({
          row: { original },
        }: {
          row: {
            original: CustomRolePermissionDto;
          };
        }) => (
          <DeletePermissionFromCustomRoleButton
            permission={original}
            openCustomRolePermissionDeleteModal={openCustomRolePermissionDeleteModal}
          />
        ),
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [openCustomRolePermissionDeleteModal, isLoading],
  );

  return (
    <RichTable
      id="custom-role-permissions"
      title="Permissions"
      columns={tableColumns}
      data={permissions as unknown as TableData[]}
      isLoading={isLoading}
      fetchError={null}
      errorSubject={`permissions for the custom role`}
      searchFieldLabel="Filter by id or alias"
      onSearchChange={() => void 0}
      createButtonTitle="Add"
      onCreateButtonClick={onAddPermissionBtnClick}
      permissions={{
        list: 'iam.custom-role.list',
        create: 'iam.custom-role.create',
      }}
      hideSearch
    />
  );
};
